import { Expose } from "class-transformer";
import { DirectlyAssessmentBase } from "domain/model/base";

export default class DirectlyAssessment extends DirectlyAssessmentBase {
  @Expose({name: "company_name"})
  companyName?: string;
};
